import { ScriptService } from './../../../../services/cms/script.service';
//Angular
import { Component, OnInit, ViewContainerRef, ChangeDetectionStrategy, ViewEncapsulation, Compiler,  Inject, Renderer } from "@angular/core";

//Services
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { Router } from "@angular/router";
import { RoutesService } from "./../../../../services/core/routes.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { CookieService } from "../../../../services/core/cookie/cookie.service";
import { Mappings } from "../../../../shared/mapping";
import { TranslateService } from "@ngx-translate/core";
import { SeoService } from "../../../../services/core/seo.service";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";
import { CurrencyService } from '../../../../services/cms/currency.service';
import { Observable } from 'rxjs/Observable';
@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  template: ""
})

export class ClientAreaCatalogPrivateComponent implements OnInit {
  constructor
    (
      private _compiler: Compiler,
      private componentHelper: ComponentHelperService,
      private _elementRef: ViewContainerRef,
      private templateService: TemplateService,
      private clientAreaService: ClientAreaService,
      private cmsComponentService: CmsComponentService,
      private authService: AuthService,
      private router: Router,
      @Inject('isBrowser') private isBrowser: boolean,
      private seo: SeoService,
      private renderer: Renderer,
      @Inject(DOCUMENT) private document: any
    ) { }
  subManager = new Subscription();
  requestDataFromMultipleSources(UserId): Observable<any[]> {
    let response1 = this.cmsComponentService.getHeaderData();
    let response2 = this.cmsComponentService.getSideMenuData();
    let response4 = this.clientAreaService.getClientAreaCatalogPrivate(UserId);

    // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
    return Observable.forkJoin([response1, response2, response4]);
  }
  ngOnInit() {
    if (!this.authService.GetData().isAuthenticated) {
      this.router.navigate([""]);
    }
    if (this.isBrowser) {
      let UserId = this.authService.GetUserId();
      let PageInfo: any;
      let header: any;
      let SideMenu: any;
      let fork = this.requestDataFromMultipleSources(UserId).subscribe(result => {
        //console.log(result)
        header = result[0];
        if (result[1].Categories) {
          header.Categories = result[1].Categories;
          SideMenu = result[1];
        }
        if (SideMenu) {
          result[2].SideMenuData = SideMenu;
        }

        if (UserId !== undefined) {
          PageInfo = result[2];


          //Creating subcomponent whith the selected template to inject
          let subComponent = this.createSubComponent(PageInfo, UserId, header);

          this._elementRef.clear();
          //injecting created component (OK)
          this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
          let orderNotFoundSub = this.templateService.getComponentTemplate("notfoundPageTemplate").subscribe(result => {
            PageInfo = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(PageInfo, UserId, header)
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
          });

          this.subManager.add(orderNotFoundSub);
        }
      });
      this.subManager.add(fork);
    }
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subManager.unsubscribe();
  }

  private createSubComponent(template: any, orderId: string, header: any) {
    @Component({
      template: template.TemplateHtml
    })

    class ChildComponent implements OnInit {
      constructor
        (
          private languageService: LanguageService,
          private authService: AuthService,
          private routesService: RoutesService,
          @Inject('CookieService') private cookie: CookieService,
          private router: Router,
          @Inject('isBrowser') private isBrowser: boolean,
          private seoService: SeoService,
          public currency: CurrencyService,
          private translateService: TranslateService,
          private breadcrumbsService: BreadcrumbsService,
          private mappings: Mappings,
          private scriptService: ScriptService
        ) { }

      private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
      private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
      private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
      private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
      private areaClientiCatalogoRiservato: string[] = this.routesService.getRoutePath('RESERVED - CATALOG');
      private isActiveInvoicesModule: boolean = template.isActiveInvoicesModule;
      private isCatalogPrivateActive: boolean = template.isCatalogPrivateActive;
      footerData: any = template.footerData;
      headerData: any = header;
      private pageIsInit: boolean = false;
      private pageIsAfterViewInit: boolean = false;
      private sideMenuData: any = template.SideMenuData;
      private breadcrumbs: Breadcrumbs[] = template.BreadcrumbsInfo;
      subManager = new Subscription();
      products = template.ProductPrivateList;

      ngOnInit() {
        this.sideMenuData.Categories = this.headerData.Categories;
        setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
      }

      ngAfterViewChecked() {
        if (!this.isBrowser || this.pageIsInit) {
          return;
        }

        //hiding of loading panel after we get all data we need
        this.routesService.hidePageLoader();

        this.pageIsInit = true;
      }
      getClassforMenuClientArea() {
        let result;
        if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
          result = "col-md-3 col-sm-3"
        }
        else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
          result = "col-md-3 col-sm-3"
        }
        else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
          result = "col-md-4 col-sm-4"
        }
        return result
      }
      ngAfterViewInit(): void {
        if (!this.isBrowser || this.pageIsAfterViewInit) {
          return;
        }
        this.pageIsAfterViewInit = true;
      }

      ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
      }
    }

    return ChildComponent;
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/client-area-catalog-private.component.ts